var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBrickWall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "red",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-brick-wall-icon lucide-brick-wall",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    x: 3,
    y: 3,
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 9v6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 15v6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3v6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 15h18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9h18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8 15v6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 3v6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrickWall);
export default __webpack_public_path__ + "static/media/brick-wall.9a1e90740130a12274cfd833d54732b9.svg";
export { ForwardRef as ReactComponent };